import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { deleteConfirmModal } from "../../../helpers/DeleteValidate";

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
    list: [],
    report: null,
};

export const VehiclePlates = createSlice({
    name: "VehiclePlates",
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        setList: (state, action) => {
            state.list = action.payload;
        },
        setReport: (state, action) => {
            state.report = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },
        clearReport: (state) => {
            state.report = initialState.report;
        },
        clearState: () => {
            return initialState;
        },
    },
});
export const {
    setPagination,
    setList,
    setReport,
    clearPagination,
    clearList,
    clearReport,
    clearState,
} = VehiclePlates.actions;

export default VehiclePlates.reducer;

// Actions
export const startSaveLicensePlate = (
    values,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/vehicle-plates/create`,
            "POST",
            values
        );

        if (resp.success) {
            callback(resp.success);

            Swal.fire({
                title: "Éxito",
                text: "Placas vehiculares registradas.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startEditLicensePlate = (
    values,
    license_plate_id,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/vehicle-plates/edit/${license_plate_id}`,
            "PUT",
            values
        );

        if (resp.success) {
            callback(resp.success);
            Swal.fire({
                title: "Éxito",
                text: "Placas vehiculares editadas.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteLicensePlate = (
    license_plate_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `operators/vehicle-plates/delete/${license_plate_id}`,
                "DELETE"
            );

            if (resp.success) {
                callback(resp.success);
                Swal.fire({
                    title: "Éxito",
                    text: "Placas vehiculares eliminadas.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 8000,
                });
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};

export const startShowReport = ({ user_type }) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("user_type", user_type);

        const resp = await Call(
            "operators/vehicle-plates/report",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setReport(resp.success));
        }

        dispatch(stopUILoading());
    };
};

export const startExportLicensePlates = () => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("export", 1);

        const resp = await CallWithFormDataFile(
            "operators/vehicle-plates/report",
            "GET",
            params.toString()
        );

        downloadBlob(resp, "Reporte de placas vehiculares");

        dispatch(stopUILoading());
    };
};
